import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import { GatsbyImage } from "gatsby-plugin-image";
import React, { useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Button from "../../../shared/components/atoms/button/button";
import HeartRating from '../../../shared/components/atoms/heart-rating/heart-rating';
import ShoppingModal from '../../../shared/components/molecules/shopping-modal/shopping-modal';
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import YouTube from 'react-youtube';
import './section-product-banner.scss';

const SectionProductBanner = ({ contentInfo, productStage, setProductStage, productRating }) => {

    const { homeLink } = useHomeLinkMode();
    const [activeShoppingModal, setActiveShoppingModal] = useState(false);
    const [activeTab, setActiveTab] = useState("IMG");

    const optionsVideo = {
        height: '400px',
        width: '100%',
    };

    const videoUrl = contentInfo.urlVideoComercial ? contentInfo.urlVideoComercial : null
    const videoID = videoUrl !== null ? videoUrl.split('/')[videoUrl.split('/').length - 1] : null;
    const secondId = videoUrl !== null ? (videoID.includes("watch") ? videoID.split('=')[1].replace(" ", "") : videoID) : null

    const options = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, next) => <p className="f-m-product-banner__description">{next}</p>
        }
    };
    const getImagesByStage = (itemIndex) => {
        const productImages = contentInfo.etapasDelProducto[itemIndex].imagenesDelProducto.map((info, index) => {
            return (
                <div key={index} className="f-m-product-banner__product-image">
                    <GatsbyImage
                        image={info.gatsbyImageData}
                        alt={info.description}
                    />
                </div>
            )
        })
        return productImages
    }
    const getImagesNoStage = () => {
        const productImages = contentInfo.imagenesAdicionalesDelProducto.map((info, index) => {
            return (
                <div key={index} className="f-m-product-banner__product-image">
                    <GatsbyImage
                        image={info.gatsbyImageData}
                        alt={info.description}
                    />
                </div>
            )
        })
        return productImages
    }

    const handleRedirectSample = () => {
        let cmsRedirection = contentInfo?.ctaRedireccionPideUnaMuestra || "productos/muestra-gratis/"
        location.href = homeLink + cmsRedirection
    }

    const NextArrow = (props) => {
        const { onClick } = props;
        return (
            <span
                className={"f-m-slider-product-banner-next"}
                onClick={onClick}
            />
        );
    }
    const PrevArrow = (props) => {
        const { onClick } = props;

        return (
            <span
                className={"f-m-slider-product-banner-prev"}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 250,
        draggable: false,
        arrows: true,
        initialSlide: 1,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    infinite: false,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    arrows: false
                }
            }]
    }

    return (
        <section className="f-m-product-banner">
            {activeShoppingModal &&
                <ShoppingModal setActiveShoppingModal={setActiveShoppingModal} />
            }
            <div
                className="f-m-product-banner__return"
                onClick={() => { location.href = homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "productos/") + contentInfo.categoria[0].idCategoria }}
            >
                <span className="f-m-product-banner__return-arrow icon-ico-button-left-arrow"></span>
                <p className="f-m-product-banner__return-cta">Volver a productos</p>
            </div>
            <div className="f-m-product-banner__content">
                <div className="f-m-product-banner__interaction">
                    <div className="f-m-product-banner__interaction-tabs-container">
                        <div className="f-m-product-banner__interaction-tabs">
                            <button className={"f-m-product-banner__interaction-tab " + (activeTab === "IMG" ? "__active" : "")}
                                onClick={() => {
                                    if (activeTab !== "IMG") {
                                        setActiveTab("IMG")
                                    }
                                }}
                            >
                                Imágenes del producto
                            </button>
                            {contentInfo.urlVideoComercial &&
                                <button className={"f-m-product-banner__interaction-tab " + (activeTab === "VID" ? "__active" : "")}
                                    onClick={() => {
                                        if (activeTab !== "VID") {
                                            setActiveTab("VID")
                                        }
                                    }}
                                >
                                    Comercial
                                </button>
                            }
                        </div>
                        <div className="f-m-product-banner__interaction-tabs-separator"></div>
                    </div>
                    <div className="f-m-product-banner__slider-container">
                        {activeTab === "IMG" ?
                            <Slider {...settings} className="f-m-product-banner__slider">
                                {contentInfo.etapasDelProducto ?
                                    getImagesByStage(productStage)
                                    :
                                    (contentInfo.imagenesAdicionalesDelProducto) &&
                                    getImagesNoStage()
                                }
                            </Slider>
                            :
                            videoUrl !== null &&
                            <YouTube
                                videoId={secondId}
                                opts={optionsVideo}
                                containerClassName="f-m-product-banner__video"
                            />

                        }

                    </div>
                </div>
                <div className="f-m-product-banner__info-box">
                    <div className="f-m-product-banner__info">
                        <div className="f-m-product-banner__info-shadow" />
                        <div className="f-m-product-banner__info-content">
                            <div className="f-m-product-banner__rating">
                                <HeartRating
                                    rate={productRating ? (productRating.userRate ? productRating.rate : productRating.averageRate) : (contentInfo.ratingValue ? contentInfo.ratingValue : 0)}
                                    ratingsNumber={productRating ? productRating.countRate : (contentInfo.reviewCount ? contentInfo.reviewCount : 0)}
                                    readOnly={true}
                                />
                            </div>
                            <h2 className="f-m-product-banner__title">
                                {contentInfo.titulo &&
                                    contentInfo.titulo
                                }
                            </h2>
                            {contentInfo.descripcionCompleta ? contentInfo.descripcionCompleta.raw && documentToReactComponents(JSON.parse(contentInfo.descripcionCompleta.raw), options) : "-"}
                            {contentInfo.etapasDelProducto &&
                                <>
                                    <h3 className="f-m-product-banner__stages-title">Etapas:</h3>
                                    <div className="f-m-product-banner__stages">
                                        {
                                            contentInfo.etapasDelProducto.map((info, index) => {
                                                return (
                                                    <div
                                                        key={index}
                                                        className={"f-m-product-banner__stage-button " + (productStage === index ? "__active" : "")}
                                                        onClick={() => {
                                                            setProductStage(index)
                                                            getImagesByStage(index)
                                                        }}
                                                    >
                                                        <button>{info.etapa}</button>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </>
                            }
                            <div className="f-m-product-banner__buttons-container">
                                <Button
                                    className="f-a-button__primary-blue f-a-button__big"
                                    id="f-a-button__product-banner-buy"
                                    onclick={() => { setActiveShoppingModal(true) }}
                                    copy={"Comprar"}
                                />
                                {contentInfo.tieneMuestraActiva && 
                                    <Button
                                        className="f-a-button__secondary-blue f-a-button__big"
                                        id="f-a-button__product-banner-sample"
                                        onclick={handleRedirectSample}
                                        copy={contentInfo?.ctaPideUnaMuestra || "Pide una muestra"}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SectionProductBanner
